import ContactInviteCard from './ContactInviteCard';

export default ContactInviteCard;


// WEBPACK FOOTER //
// ./src/components/ContactInviteCard/index.js